<div fxLayout>
  <div fxFlex="1 0 auto">
    <h1 class="title">{{ title() }}</h1>
  </div>
  @if (items().length > 0) {
    <div fxFlex="0 1 auto">
      <hypecast-generic-actions [items]="items()"></hypecast-generic-actions>
    </div>
  }
  <div fxFlex="0 1 auto">
    <button mat-icon-button [matTooltip]="closeTooltipText()" (click)="emitCloseClick.emit(true)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
@if (dividerIsVisible()) {
  <mat-divider></mat-divider>
}
